import Icon from "@mui/material/Icon";
import Contato from "pages/LandingPages/Contato";
import Institucional from "pages/LandingPages/Institucional";
import Qualidade from "pages/LandingPages/Qualidade";
import Industrial from "pages/LandingPages/Industrial";
import Servicos from "pages/LandingPages/ProdutosServicos";

const routes = [
  {
    name: "Sobre",
    icon: <Icon>account_balance</Icon>,
    route: "/institucional",
    component: <Institucional />,
    key: "institucional",
  },
  {
    name: "Estrutura",
    icon: <Icon>factory</Icon>,
    route: "/estrutura-industrial",
    component: <Industrial />
  },
  {
    name: "Produtos e Serviços",
    icon: <Icon>widgets</Icon>,
    route: "/usinagem-precisao",
    component: <Servicos />
  },
  {
    name: "Qualidade",
    icon: <Icon>verified</Icon>,
    route: "/qualidade",
    component: <Qualidade />
  },
  {
    name: "Contato",
    icon: <Icon>mail_outline </Icon>,
    route: "/contato",
    component: <Contato />,
    key: "contato",
  },
];

export default routes;
